import React from "react";
import FileSaver from "file-saver";

import { downloadTransferExportBanqueProvider } from "../../lib/api/providers";
import { Modal } from "antd";

const DownloadTransferOrder = ({ setErrorMsg, token, transferOrderId }) => {
  const downloadTransferOrder = async (filters = {}, token) => {
    try {
      const transferOrderResponse = await downloadTransferExportBanqueProvider.post(
        "/",
        { ...filters },
        {
          // responseType: "arraybuffer",
          headers: {
            Authorization: token
          }
        }
      );
      const transferOrders = transferOrderResponse.data;
      const headers = transferOrderResponse.headers || {};
      const contentDisposition = headers["content-disposition"] || "";
      let filename = contentDisposition.split(/filename[\s]*=[\s]*/gi)[1];
      filename = filename.replace(/[^A-Z0-9\s._]+/gi, "");

      FileSaver.saveAs(
        new Blob([transferOrders], {
          type: "text/csv"
        }),
        filename
      );
    } catch (e) {
      let errorMsg = "Une erreur est survenue dans le téléchargement";

      if (e.response && e.response.data) {
        errorMsg = e.response.data.data ? e.response.data.data : e.response.data.error;
      }
      Modal.error({
        title: "Erreur lors du téléchargement",
        content: errorMsg
      });
    }
  };

  return (
    <a
      className="flex cursor-pointer underline font-bold text-orange-400 text-lg mb-4"
      onClick={() => downloadTransferOrder({ _id: transferOrderId }, token)}
    >
      Export banque (csv)
    </a>
  );
};

export default DownloadTransferOrder;



// WEBPACK FOOTER //
// src/components/downloadTransferOrder/DownloadExportBanque.js